import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";
import { apiFetch } from "./apiFetch";

/**
 * Bulk update one or more fields across many rental leases.
 * Body: { account_id, _ids, status?, property_address?, landlords?, asset_id?,
 *         start_date?, end_date?, rent_amount?, security_deposit?, pet_deposit? }
 * Returns { matched, modified }.
 */
export async function bulkUpdateRentalLeases(payload) {
  const resp = await apiFetch(serverInfo.serverUrl + "/bulkUpdateRentalLeases", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  checkResponse(resp);
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || "Bulk update failed");
  }
  return resp.json();
}
